import Analytics from "layouts/dashboards/analytics";
import ProfileOverview from "layouts/pages/profile/profile-overview";
import Settings from "layouts/pages/account/settings";
import SignInBasic from "layouts/authentication/sign-in/basic";
import SignInCover from "layouts/authentication/sign-in/cover";
import SignInIllustration from "layouts/authentication/sign-in/illustration";
import SignUpCover from "layouts/authentication/sign-up/cover";  // ✅ Added Sign-Up Import
import ResetCover from "layouts/authentication/reset-password/cover";
import MDAvatar from "components/MDAvatar";
import Reports from "Reports/Reports";
import Icon from "@mui/material/Icon";
import { Box, Typography } from "@mui/material";


// Images
// import profilePicture from "assets/images/team-3.jpg";

// import Location from "track/Location";
import Dashboard from "Dashboard";


// import AdminRegistration from "track/Adminregistration";
import AdminDasboard from "track/Admindashboard";
import CustomerProfileDetails from "track/CustomerProfileDetails";

import SMTPConfigurationDetails from "track/Smtp";

import Location from "track/Location";
import CareCoordinatorsDetails from "track/CareCoordinators";
import DoctorsRegistration from "track/Doctors";
import PatientDetails from "track/Patients";
import PatientRegistration from "track/Patients";
import DPmapping from "track/DPmapping";
import DoctorLoginPatientDetails from "track/DoctorLoginPatientDetails";
import PatientLoginDoctorDetails from "track/PatientLoginDoctorDetails";
import Devicemapping from "track/DeviceMapping";
import DeviceData from "track/DeviceData";
import HospitalProfile from "track/HospitalProfile";
import DoctorMapDetails from "track/DoctormapDeatils";
import HospitalDoctor from "track/HospitalDoctor";
import DoctorPatientmapping from "track/DPmapping";
import DoctorPatientMapping from "track/DPmapping";
import CareCoordinatorsDashboard from "track/CareCoordinatorDashboard";
import DeviceDetails from "track/DeviceDetails";
import SuperDashboard from "track/SuperDashboard";
import NotificationDetails from "track/NotificationDetails";
import SOSNotificationPage from "track/SOSNotificationPage";
import DoctorNotificationDetails from "track/DoctorNotification";
import PatientDashboard from "track/PatientDashboard";
import DoctorDashboard from "track/DoctorDashboard";
import DeviceInventory from "track/DeviceDetails";
import PatientLoginDeviceDetails from "track/PatientLoginDeviceDetails";
import MyReadings from "track/Myreadings";
import Myprescription from "track/Myprescription";
import SnapMeal from "track/SnapMeal";

const loginData = JSON.parse(localStorage.getItem("loginData"));
const userRole = loginData?.role;
const username = loginData?.username;

let routes = [];

if (userRole === "ROLE_SUPER") {
  routes = [
    {
      type: "route",
      name: "Dashboard",
      key: "SuperDashboard",
      icon: <Icon fontSize="small">SuperDashboard</Icon>,
      route: "/SuperDashboard",
      component: <SuperDashboard />,
    },
    {
      type: "route",
      name: "SOS Notifications",
      key: "SOSNotifications",
      icon: <Icon fontSize="small">warning</Icon>,
      route: "/track/sos-notifications",
      component: <SOSNotificationPage />,
    },
    {
      type: "route",
      name: "Location",
      key: "location",
      icon: <Icon fontSize="small">Location</Icon>,
      route: "/track/location",
      component: <Location />,
    },
    {
      type: "route",
      name: "Care Coordinators",
      key: "carecoordinatorsdetails",
      icon: <Icon fontSize="small">Care Coordinators</Icon>,
      route: "/track/carecoordinatorsdetails",
      component: <CareCoordinatorsDetails />,
    },



  ];

} else if (userRole === "ROLE_CARE_COORDINATOR") {
  routes = [
    {
      type: "route",
      name: "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: "/dashboard",
      component: <CareCoordinatorsDashboard />,
    },
    // {
    //   type: "route",
    //   name: "Admin",
    //   key: "admin",
    //   icon: <Icon fontSize="small">ADMIN</Icon>,
    //   route: "/AdminDetails",
    //   component: <AdminDetails/>,
    // },

    // {
    //   type: "route",
    //   name: "Location",
    //   key: "location",
    //   icon: <Icon fontSize="small">Location</Icon>,
    //   route: "/track/Location",
    //   component: <Location />,
    // },


    // {
    //   type: "route",
    //   name: "Customer Type",
    //   key: "customertype",
    //   icon: <Icon fontSize="small">customer type</Icon>,
    //   route: "/track/Customertype",
    //   component: <Customertype/>,
    // },
    // {
    //   type: "route",
    //   name: "Customers1",
    //   key: "customers",
    //   icon: <Icon fontSize="small">customers</Icon>,
    //   route: "/track/Customers",
    //   component: <Customers/>,
    // },
    // {
    //   type: "route",
    //   name: "Customers",
    //   key: "customers",
    //   icon: <Icon fontSize="small">customers</Icon>,
    //   route: "/track/CustomerDetails",
    //   component: <CustomerDetails/>,
    // },
    //  {
    //   type: "route",
    //   name: "Customers",
    //   key: "customers",
    //   icon: <Icon fontSize="small">customers</Icon>,
    //   route: "/track/CustomerDetails",
    //   component: <CustomerDetails/>,
    // },
    {
      type: "route",
      name: "Hospital Profile",
      key: "HospitalProfile",
      icon: <Icon fontSize="small">Hospital Profile</Icon>,
      route: "/track/HospitalProfile",
      component: <HospitalProfile />,
    },
    {
      type: "route",
      name: "Doctors Profile",
      key: "Doctors",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/track/Doctors",
      component: <DoctorsRegistration />,
    },


    {
      type: "route",
      name: "Patients Profile",
      key: "PatientRegistration",
      icon: <Icon fontSize="small">Patients Profile</Icon>,
      route: "/track/PatientRegistration",
      component: <PatientRegistration />,
    },


    {
      type: "route",
      name: "Duty & Rendering Allocation",
      key: "DoctorMapDetails",
      icon: <Icon fontSize="small">Duty & Rendering Doctor Allocation</Icon>,
      route: "/track/DoctorMapDetails",
      component: <DoctorMapDetails />,
    },
    {
      type: "route",
      name: "Patient–Doctor Assignment",
      key: "DPmapping",
      icon: <Icon fontSize="small">Patient–Doctor Assignment</Icon>,
      route: "/track/DoctorPatientMapping",
      component: <DoctorPatientMapping />,
    },

    {
      type: "route",
      name: "Device Inventory",
      key: "DeviceInventory",
      icon: <Icon fontSize="small">Device Inventory</Icon>,
      route: "/track/DeviceInventory",
      component: <DeviceInventory />,
    },
    {
      type: "route",
      name: "Patient–Device Association",
      key: "Devicemapping",
      icon: <Icon fontSize="small">Patient Device Mapping</Icon>,
      route: "/track/Devicemapping",
      component: <Devicemapping />,
    },
    //  {
    //     type: "route",
    //     name: "Device Data",
    //     key: "DeviceData",
    //     icon: <Icon fontSize="small">Device Data</Icon>,
    //     route: "/track/DeviceData",
    //     component: <DeviceData/>,
    //   },
    {
      type: "route",
      name: "SOS Notifications",
      key: "SOSNotifications",
      icon: <Icon fontSize="small">warning</Icon>,
      route: "/track/sos-notifications",
      component: <SOSNotificationPage />,
    },
    {
      type: "route",
      name: "Notification Details",
      key: "NotificationDetails",
      icon: <Icon fontSize="small">Notification Details</Icon>,
      route: "/track/NotificationDetails",
      component: <NotificationDetails />,
    },


    //  {
    //     type: "route",
    //     name: "SMTP Configuration",
    //     key: "SMTPConfigurationDetails",
    //     icon: <Icon fontSize="small">SMPT Configuration</Icon>,
    //     route: "/track/SMTPConfigurationDetails",
    //     component: <SMTPConfigurationDetails />,
    //   },

    // {
    //   type: "route",
    //   name: "Reports",
    //   key: "reports",
    //   icon: <Icon fontSize="small">reports</Icon>,
    //   route: "/dashboards/reports",
    //   component: <Reports />,
    // },
  ];
} else if (userRole === "ROLE_DOCTOR") {
  routes = [

    {
      type: "route",
      name: "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: "/DoctorDashboard",
      component: <DoctorDashboard />,
    },
    {
      type: "route",
      name: "Patients Profile",
      key: "DoctorLoginPatientDetails",
      icon: <Icon fontSize="small">DoctorLoginPatientDetails</Icon>,
      route: "/track/DoctorLoginPatientDetails",
      component: <DoctorLoginPatientDetails />,
    },
    //  {
    //   type: "route",
    //   name: "Device Inventory",
    //   key: "DeviceInventory",
    //   icon: <Icon fontSize="small">Device Inventory</Icon>,
    //   route: "/track/DeviceInventory",
    //   component: <DeviceInventory/>,
    // },


  ];
} else if (userRole === "ROLE_HOSPITAL") {
  routes = [

    {
      type: "route",
      name: "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: "/dashboard",
      component: <Dashboard />,
    },
    {
      type: "route",
      name: "Hospital Doctor",
      key: "HospitalDoctor",
      icon: <Icon fontSize="small">HospitalDoctor</Icon>,
      route: "/track/HospitalDoctor",
      component: <HospitalDoctor />,
    },


  ];
} else if (userRole === "ROLE_USER") {
  routes = [

    {
      type: "route",
      name: "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: "/PatientDashboard",
      component: <PatientDashboard />,
    },
    {
      type: "route",
      name: "Doctors Profile",
      key: "PatientLoginDoctorDetails",
      icon: <Icon fontSize="small">PatientLoginDoctorDetails</Icon>,
      route: "/track/PatientLoginDoctorDetails",
      component: <PatientLoginDoctorDetails />,
    },

    {
      type: "route",
      name: "Device Details",
      key: "PatientLoginDeviceDetails",
      icon: <Icon fontSize="small"> Device Mapping</Icon>,
      route: "/track/PatientLoginDeviceDetails",
      component: <PatientLoginDeviceDetails />,
    },

    {
      type: "route",
      name: "My Readings",
      key: "MyReadings",
      icon: <Icon fontSize="small">My Readings</Icon>,
      route: "/track/MyReadings",
      component: <MyReadings />,
    },
    {
      type: "route",
      name: "My Prescription",
      key: "Myprescription",
      icon: <Icon fontSize="small">My prescription</Icon>,
      route: "/track/Myprescription",
      component: <Myprescription />,
    },
    {
      type: "route",
      name: "SnapMeal",
      key: "SnapMeal",
      icon: <Icon fontSize="small">SnapMeal</Icon>,
      route: "/track/SnapMeal",
      component: <SnapMeal />,
    },

  ];
} else if (userRole === "ROLE_USER") {
  routes = [
    // {
    //   type: "route",
    //   name: "Dashboard",
    //   key: "dashboard",
    //   icon: <Icon fontSize="small">Dashboard</Icon>,
    //   route: "/track/FarmerDasboard",
    //   component: <FarmerDasboard />,
    // },
    // {
    //   type: "route",
    //   name: "Farmers",
    //   key: "farmer",
    //   icon: <Icon fontSize="small">Farmer</Icon>,
    //   route: "/track/FarmerProfile",
    //   component: <FarmerProfile />,
    // },
    // {
    //   type: "route",
    //   name: "Device Details",
    //   key: "farmer",
    //   icon: <Icon fontSize="small">Device Details</Icon>,
    //   route: "/track/FarmerDeviceDetails",
    //   component: <FarmerDeviceDetails />,
    // },

  ];
}




export default routes;
